/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

const ipLoopBack = `${process.env.VUE_APP_URL}`

async function getData(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async function getUserPermission () {
  const ret = await getData(`${ipLoopBack}/api/permission`);
  return ret;
}

async function getUserInfo () {
  const ret = await getData(`${ipLoopBack}/api/user`);
  return ret;
}

function checkPermission (permissions, need) {
  return permissions.some(x => x.includes(need))
}

export default {
  checkPermission,
  getUserPermission,
  getUserInfo,
}
